import { render } from "./SmallLoader.vue?vue&type=template&id=39b25480&scoped=true"
import script from "./SmallLoader.vue?vue&type=script&lang=js"
export * from "./SmallLoader.vue?vue&type=script&lang=js"

import "./SmallLoader.vue?vue&type=style&index=0&id=39b25480&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39b25480"]])

export default __exports__